import {
    withHeaders,
    instance as axiosInstance,
} from '../core/util/axiosInstance';
import { MutationFunction, UseMutationResult, useMutation } from 'react-query';
import { AxiosResponse } from 'axios';
import { getDefaultHeaders, useAlert } from '../core';
import { commonShowAlert } from '../lib';
import { FILE_UPLOAD_SUCCESS_MSG } from '../pages/job-manager/job-manager-helper';

interface PostDownloadJobProps {
    token: string;
    query: string;
    fileType: string;
    password?: string;
}

const createDownloadJob: MutationFunction<
    AxiosResponse<any>,
    PostDownloadJobProps
> = async (props: PostDownloadJobProps) => {
    const { token, fileType, query, password } = props;
    const headers = getDefaultHeaders(token);
    const downloadJobUrl = `/jobs/download`;
    return axiosInstance().post(
        downloadJobUrl,
        { tql: query, fileType, filePassword: password },
        withHeaders(headers)
    );
};

export const useCreateDownloadJob = (): UseMutationResult<
    AxiosResponse<any>,
    unknown,
    PostDownloadJobProps
> => {
    const { showAlert, hideAlert, showErrorDetails } = useAlert();

    return useMutation(createDownloadJob, {
        onSuccess: () => {
            commonShowAlert(
                showAlert,
                hideAlert,
                'success',
                FILE_UPLOAD_SUCCESS_MSG
            );
        },
        onError: (error: any) => {
            const errorMessage: string =
                error?.data?.message ?? 'Unable to create download job';
            commonShowAlert(
                showAlert,
                hideAlert,
                'error',
                errorMessage,
                JSON.stringify(error?.data ?? ''),
                showErrorDetails
            );
        },
    });
};
